const state = {
  list: [],
}

const getters = {
}

const mutations = {
  setList (state, list) {
    state.list = list
  },
}

const actions = {
  productDetail ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/tb-dg/product/search/product-detail', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    }).then(res => {
      const converter = window.OpenCC.Converter({ from: 'cn', to: 'tw' })
      res.data.model = JSON.parse(converter(JSON.stringify(res.data.model)))
      return res
    })
  },
  // 字段名稱參照：https://open.taobao.global/doc/api.htm#/api?cid=21&path=/traffic/item/search&methodType=GET/POST
  searchKeywordQuery ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/tb-dg/product/search/keyword-query', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
